// extracted by css-extract-rspack-plugin
export default {"ItemLink":"AutomaticDashboardApp-module__ItemLink___rTesG","SuggestionsSidebarWrapper":"AutomaticDashboardApp-module__SuggestionsSidebarWrapper___NEZFO"};